import React, { Children, FC, ReactElement } from "react";

import { Route, RouteProps } from "../Route/Route";
import {
  Routes as ReactRouterRoutes,
  RoutesProps,
  Route as ReactRouterRoute,
  RouteProps as ReactRouteProps,
} from "react-router-dom";
import { useRoutes } from "@Libs/Router/hooks/useRoutes";
import api from "@api";
import { Navigate } from "../Navigate/Navigate";
import { useLocation } from "@Libs/Router/hooks/useLocation";

type Props = RoutesProps;

export const Routes: FC<Props> = ({ children, ...props }) => {
  const { route } = useRoutes();
  const location = useLocation();
  const routesProps: ReactRouteProps & RouteProps[] = [];

  const addRoute = (child: ReactElement) => {
    const {
      fragments,
      withLocale,
      matchAny,
      element,
      private: privateRoute,
      ...rest
    } = child.props;

    if (location.pathname !== "/users/sign_in") {
      const newCookie = `redirect_url_after_log_in=${location.pathname}; path=/`;
      document.cookie = newCookie;
    }

    const composedElement =
      privateRoute && !api.isAuthHeaderSet() ? (
        <Navigate to={["USERS", "SIGN_IN"]} reload />
      ) : (
        element
      );

    routesProps.push({
      ...rest,
      element: composedElement,
      path: route(fragments, {
        withLocale: false,
        matchAny,
      }),
    });

    if (withLocale) {
      routesProps.push({
        ...rest,
        element: composedElement,
        path: route(fragments, { withLocale: true, matchAny }),
      });
    }
  };

  Children.forEach(children, (child: ReactElement) => {
    if (child.type !== Route) {
      throw new Error("Routes can only contain Route or Outlet components");
    }

    addRoute(child);
  });

  return (
    <ReactRouterRoutes {...props}>
      {routesProps.map((props) => (
        <ReactRouterRoute key={props.path} {...props} />
      ))}
    </ReactRouterRoutes>
  );
};
